import { Component, OnInit, ViewEncapsulation, ViewChild, Input, OnChanges  } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';

import { DiagramComponent, Diagram, NodeModel, ConnectorModel, SnapSettingsModel, LayoutModel, DataSourceModel, TextModel, DecoratorModel, ShapeStyleModel, UserHandleModel, SelectorModel, SelectorConstraints, ToolBase, MoveTool, MouseEventArgs, cloneObject, randomId, IElement, ContextMenuSettingsModel, BpmnBoundary, BpmnDataObjects, BpmnEvents, BpmnGateways, BpmnLoops, BpmnShapeModel, BpmnTasks, BpmnTriggers, DiagramBeforeMenuOpenEventArgs, NodeConstraints } from '@syncfusion/ej2-angular-diagrams'
import { MenuEventArgs } from '@syncfusion/ej2-angular-navigations';
import { DataManager, DataUtil, Query } from '@syncfusion/ej2-data';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { createElement } from 'node_modules/@syncfusion/ej2-base';
import { DemoService } from 'src/app/demo.service';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { AppRoute } from 'src/app/shared/models/appRoute.model';
import { AppRouteCreateWidgetComponent } from '../app-route-create-widget/app-route-create-widget.component';
import { AppRouteUpdateWidgetComponent } from '../app-route-update-widget/app-route-update-widget.component';
import { AppRouteWidgetComponent } from '../app-route-widget/app-route-widget.component';


@Component({
  selector: 'app-app-routes-diagram-hierarchial',
  templateUrl: './app-routes-diagram-hierarchial.component.html',
  styleUrls: ['./app-routes-diagram-hierarchial.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppRoutesDiagramHierarchialComponent implements OnInit, OnChanges {


     // setup as observable?
     @Input() item_id?; // impliments on changes.
     @Input() item_data?; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = '';
     @Input() show_buttons? = 'no'; // yes | no
     @Input() widget_title? = '';
     @Input() widget_size?; // side | abstract | full
    @Input() current_field_name?;
  
    @Input() promotion_id: number;
    @Input() current_route: any;
  
    array_of_routes: any[];
    search_model: AppRoute;
    public contextMenuSettings: ContextMenuSettingsModel;



    bsModalRef: BsModalRef;
    // MODAL
    modalRef: BsModalRef;

  @ViewChild("diagram_ONE")
    public diagram_ONE?: DiagramComponent;
    public snapSettings_ONE?: SnapSettingsModel;
    public items_ONE?: DataManager;
    public layout_ONE?: LayoutModel;
    public dataSourceSettings_ONE?: DataSourceModel;
    //Initializes data source
    // public data_ONE: object[] = [{
    //         Name: "Steve-Ceo"
    //     },
    //     {
    //         Name: "Kevin-Manager",
    //         ReportingPerson: "Steve-Ceo"
    //     },
    //     {
    //         Name: "Peter-Manager",
    //         ReportingPerson: "Steve-Ceo"
    //     },
    //     {
    //         Name: "John- Manager",
    //         ReportingPerson: "Peter-Manager"
    //     },
    //     {
    //         Name: "Mary-CSE ",
    //         ReportingPerson: "Peter-Manager"
    //     },
    //     {
    //         Name: "Jim-CSE ",
    //         ReportingPerson: "Kevin-Manager"
    //     },
    //     {
    //         Name: "Martin-CSE",
    //         ReportingPerson: "Kevin-Manager"
    //     }
    // ];
    app_routes_metrix_search_full: Object;
    app_routes_metrix_search_full_results: any;
    new_data: any;
    data_LOCAL_DATA_RECIEVED: {
        id: string; parentId: string; dataManager: DataManager;
        //binds the external data with node
        doBinding: (nodeModel: NodeModel, data: DataInfo, diagram_ONE: Diagram) => void;
    };



  // UserHamdles
  public handles: UserHandleModel[] = [
    {
      name: "clone",
      pathData: "M60.3,18H27.5c-3,0-5.5,2.4-5.5,5.5v38.2h5.5V23.5h32.7V18z M68.5, 28.9h-30c-3, 0-5.5,2.4-5.5,5.5v38.2c0,3,2.4,5.5,5.5,5.5h30c3,0,5.5-2.4,5.5-5.5V34.4C73.9,31.4,71.5,28.9,68.5,28.9z M68.5,72.5h-30V34.4h30V72.5z",
      visible: true,
      offset: 0,
      side: "Bottom",
      margin: { top: 0, bottom: 0, left: 0, right: 0 },
      disableConnectors: false
    }
  ];
  public selectedItems: SelectorModel = {
    constraints: SelectorConstraints.UserHandle,
    userHandles: this.handles
  };
  public getCustomTool: Function = this.getTool.bind(this);

  public getTool(action: string): ToolBase {
    let tool: ToolBase = new ToolBase({
        isProtectChange: true
    } as any);
    if (action === "clone") {


      this.gfunc.globalViewAppRouteSkipRoute(16);


      let cloneTool: CloneTool = new CloneTool((this.diagram_ONE as DiagramComponent).commandHandler);
      cloneTool.diagram_ONE = this.diagram_ONE as Diagram;

    //   console.log('Selected Action:', JSON.stringify(action) );
    //   console.log('Selected items:', this.diagram_ONE.selectedItems);

      // this.gfunc.globalViewAppRouteSkipRoute(this.diagram_ONE.selectedItems.nodes.values.name)

      return cloneTool;


    }
    return tool;
  }


// Context Menu
public contextMenuBeforeItemRender(args: MenuEventArgs) {   
    let shortCutSpan: HTMLElement = createElement('span');
    let text: string = args.item.text;
    let shortCutText: string = text === 'Cut  ' ? 'In graphical user interface (GUI), a context menu is a type of menu that appears when you perform right-click operation' : (text === 'Copy  ' ?'Ctrl + U' : 'Ctrl + Shift + I');
    shortCutSpan.textContent = shortCutText;
    args.element.appendChild(shortCutSpan);
    shortCutSpan.setAttribute('class', 'shortcut');
}


public contextMenuClick(args: MenuEventArgs): void {
// https://stackblitz.com/edit/github-w2u9mw?file=projects%2Fdiagram-vistualization%2Fsrc%2Fapp%2Fapp.component.ts

    if (this.diagram_ONE.selectedItems.nodes.length > 0) {
      const bpmnShape: BpmnShapeModel = this.diagram_ONE.selectedItems.nodes[0]
        .shape as BpmnShapeModel;


        
console.log('Selected: ', this.diagram_ONE.selectedItems.nodes[0].data);

const selected_data = this.diagram_ONE.selectedItems.nodes[0].data
const values = Object.keys(selected_data).map(key => selected_data[key]);



console.log('Finally Yep: ', values[0]);
const selected_app_route_id = values[0];

console.log('Selected Items NODES[]: ', this.diagram_ONE.selectedItems.nodes[0]);
          console.log('The Click Event:', args.item) // see if we can get the id and run my custom actions


          if (args.item.id === 'RouteAdminView'){
            this.gfunc.globalViewAppRouteSkipRoute(selected_app_route_id)
          }
          if (args.item.id === 'RouteAdminEdit'){
            this.gfunc.globalppsDistroHubAppRouteUpdateSkipRoute(selected_app_route_id)
          }

          if (args.item.id === 'RouteAdminEditModal'){
            // this.gfunc.globalppsDistroHubAppRouteUpdateSkipRoute(selected_app_route_id)
            this.openModalWithComponent_UpdateAppBaseRouteItem(values) 

          }
          if (args.item.id === 'RouteAdminViewModal'){
            // this.gfunc.globalppsDistroHubAppRouteUpdateSkipRoute(selected_app_route_id)
            this.openModalWithComponent_ViewAppBaseRouteItem(values) 

          }
          if (args.item.id === 'RouterLink'){
            // this.gfunc.globalppsDistroHubAppRouteUpdateSkipRoute(selected_app_route_id)
            // this.openModalWithComponent_ViewAppBaseRouteItem(values) 
            this.gfunc.globalRouteViewSkipRoute(values[4].routerLink);
          }

          if (args.item.id === 'RouteAdminCreateMasterChildRoute'){
            // this.gfunc.globalppsDistroHubAppRouteUpdateSkipRoute(selected_app_route_id)
            // NEW OPEN MODEL HERE -- LOAD MODAL AS COMPONENT......
            this.openModalWithComponent_CreateAppBaseRouteChildMaster(values) 
          }
          if (args.item.id === 'RouteAdminCreateTaskItemChildRoute'){
            this.openModalWithComponent_CreateAppBaseRouteChildTaskItem(values) 
          }
          

          if (args.item.id === 'Create Master Base Route'){
            this.gfunc.globalppsDistroHubAppRouteUpdateSkipRoute(selected_app_route_id)
          }

        //   if (args.item.id === 'AdhocNone'){
        //     this.gfunc.globalViewAppRouteSkipRoute(selected_app_route_id)
        //   }
                return;

      if (args.item.iconCss.indexOf('e-adhocs') > -1) {
        bpmnShape.activity.subProcess.adhoc =
          args.item.id === 'AdhocNone' ? false : true;

        //   console.log('The Click Event:', args) // see if we can get the id and run my custom actions
      }
      if (args.item.iconCss.indexOf('e-event') > -1) {
        bpmnShape.event.event = args.item.id as BpmnEvents;
      }
      if (args.item.iconCss.indexOf('e-trigger') > -1) {
        bpmnShape.event.trigger = args.item.text as BpmnTriggers;
      }
      if (args.item.iconCss.indexOf('e-loop') > -1) {
        const loop: string =
          args.item.id === ('LoopNone' as BpmnLoops) ? 'None' : args.item.id;
        if (bpmnShape.activity.activity === 'Task') {
          bpmnShape.activity.task.loop = loop as BpmnLoops;
        }
        if (bpmnShape.activity.activity === 'SubProcess') {
          bpmnShape.activity.subProcess.loop = loop as BpmnLoops;
        }
      }
      if (args.item.iconCss.indexOf('e-compensation') > -1) {
        const compensation: boolean =
          args.item.id === 'CompensationNone' ? false : true;
        if (bpmnShape.activity.activity === 'Task') {
          bpmnShape.activity.task.compensation = compensation;
        }
        if (bpmnShape.activity.activity === 'SubProcess') {
          bpmnShape.activity.subProcess.compensation = compensation;
        }
      }
      if (args.item.iconCss.indexOf('e-call') > -1) {
        const compensation: boolean =
          args.item.id === 'CallNone' ? false : true;
        if (bpmnShape.activity.activity === 'Task') {
          bpmnShape.activity.task.call = compensation;
        }
      }
      if (
        args.item.id === 'CollapsedSubProcess' ||
        args.item.id === 'ExpandedSubProcess'
      ) {
        if (args.item.id === 'ExpandedSubProcess') {
          bpmnShape.activity.activity = 'SubProcess';
          bpmnShape.activity.subProcess.collapsed = false;
        } else {
          bpmnShape.activity.activity = 'SubProcess';
          bpmnShape.activity.subProcess.collapsed = true;
        }
      }
      if (args.item.iconCss.indexOf('e-boundry') > -1) {
        let call: string = args.item.id;
        if (args.item.id !== 'Default') {
          call = args.item.id === 'BoundryEvent' ? 'Event' : 'Call';
        }
        bpmnShape.activity.subProcess.boundary = call as BpmnBoundary;
      }
      if (args.item.iconCss.indexOf('e-data') > -1) {
        const call: string =
          args.item.id === 'DataObjectNone' ? 'None' : args.item.id;
        bpmnShape.dataObject.type = call as BpmnDataObjects;
      }
      if (args.item.iconCss.indexOf('e-collection') > -1) {
        const call: boolean =
          args.item.id === 'Collectioncollection' ? true : false;
        bpmnShape.dataObject.collection = call;
      }
      if (args.item.iconCss.indexOf('e-task') > -1) {
        const task: string =
          args.item.id === 'TaskNone' ? 'None' : args.item.id;
        if (bpmnShape.activity.activity === 'Task') {
          bpmnShape.activity.task.type = task as BpmnTasks;
        }
      }
      if (args.item.iconCss.indexOf('e-gate') > -1) {
        const task: string = args.item.id.replace('Gateway', '');
        if (bpmnShape.shape === 'Gateway') {
          bpmnShape.gateway.type = task as BpmnGateways;
        }
      }
      this.diagram_ONE.dataBind();
    }
  }

  
  public contextMenu: ContextMenuSettingsModel = {
    show: true,
    items: [
        {
            text: 'Route Admin',
            id: 'RouteAdmin',
            items: [
             
              {
                text: 'View',
                iconCss: 'fa fa-external-link',
                id: 'RouteAdminViewModal',
              },
              {
                text: 'Edit',
                iconCss: 'fa fa-window-maximize',
                id: 'RouteAdminEditModal',
              },
              {
                text: 'Route Link',
                iconCss: 'fa fa-anchor',
                id: 'RouterLink',
              },
              {
                text: 'Create Master Child Route',
                iconCss: 'fa fa-road',
                id: 'RouteAdminCreateMasterChildRoute',
              },
              {
                text: 'Create Task Item Child Route',
                iconCss: 'fa fa-flask',
                id: 'RouteAdminCreateTaskItemChildRoute',
              },
              {
                text: 'View',
                iconCss: 'fa fa-eye',
                id: 'RouteAdminView',
              },
              {
                text: 'Edit',
                iconCss: 'fa fa-pencil',
                id: 'RouteAdminEdit',
              },
              // {
              //   iconCss: 'e-adhocs e-bpmn-icons e-adhoc',
              //   text: 'Ad-Hoc',
              //   id: 'AdhocAdhoc',
              // },
            ],
          },
        {
        text: 'Route Link',
        id: 'Adhoc',
        items: [
          {
            text: 'View Actual Route Page',
            iconCss: 'fa fa-anchor',
            id: 'RouterLink',
          },
          // {
          //   iconCss: 'e-adhocs e-bpmn-icons e-adhoc',
          //   text: 'Ad-Hoc',
          //   id: 'AdhocAdhoc',
          // },
        ],
      },
      // {
      //   text: 'Loop',
      //   id: 'Loop',
      //   items: [
      //     {
      //       text: 'None',
      //       iconCss: 'e-loop e-bpmn-icons e-None',
      //       id: 'LoopNone',
      //     },
      //     {
      //       text: 'Standard',
      //       iconCss: 'e-loop e-bpmn-icons e-Loop',
      //       id: 'Standard',
      //     },
      //     {
      //       text: 'Parallel Multi-Instance',
      //       iconCss: 'e-loop e-bpmn-icons e-ParallelMI',
      //       id: 'ParallelMultiInstance',
      //     },
      //     {
      //       text: 'Sequence Multi-Instance',
      //       iconCss: 'e-loop e-bpmn-icons e-SequentialMI',
      //       id: 'SequenceMultiInstance',
      //     },
      //   ],
      // },
      // {
      //   text: 'Compensation',
      //   id: 'taskCompensation',
      //   items: [
      //     {
      //       text: 'None',
      //       iconCss: 'e-compensation e-bpmn-icons e-None',
      //       id: 'CompensationNone',
      //     },
      //     {
      //       iconCss: 'e-compensation e-bpmn-icons e-Compensation',
      //       text: 'Compensation',
      //       id: 'CompensationCompensation',
      //     },
      //   ],
      // },
      // {
      //   text: 'Activity-Type',
      //   id: 'Activity-Type',
      //   items: [
      //     {
      //       text: 'Collapsed sub-process',
      //       iconCss: 'e-bpmn-icons e-SubProcess',
      //       id: 'CollapsedSubProcess',
      //     },
      //     {
      //       iconCss: 'e-bpmn-icons e-Task',
      //       text: 'Expanded sub-process',
      //       id: 'ExpandedSubProcess',
      //     },
      //   ],
      // },
      // {
      //   text: 'Boundry',
      //   id: 'Boundry',
      //   items: [
      //     {
      //       text: 'Default',
      //       iconCss: 'e-boundry e-bpmn-icons e-Default',
      //       id: 'Default',
      //     },
      //     {
      //       text: 'Call',
      //       iconCss: 'e-boundry e-bpmn-icons e-Call',
      //       id: 'BoundryCall',
      //     },
      //     {
      //       text: 'Event',
      //       iconCss: 'e-boundry e-bpmn-icons e-Event',
      //       id: 'BoundryEvent',
      //     },
      //   ],
      // },
      // {
      //   text: 'Data Object',
      //   id: 'DataObject',
      //   items: [
      //     {
      //       text: 'None',
      //       iconCss: 'e-data e-bpmn-icons e-None',
      //       id: 'DataObjectNone',
      //     },
      //     {
      //       text: 'Input',
      //       iconCss: 'e-data e-bpmn-icons e-DataInput',
      //       id: 'Input',
      //     },
      //     {
      //       text: 'Output',
      //       iconCss: 'e-data e-bpmn-icons e-DataOutput',
      //       id: 'Output',
      //     },
      //   ],
      // },
      // {
      //   text: 'Collection',
      //   id: 'collection',
      //   items: [
      //     {
      //       text: 'None',
      //       iconCss: 'e-collection e-bpmn-icons e-None',
      //       id: 'collectionNone',
      //     },
      //     {
      //       text: 'Collection',
      //       iconCss: 'e-collection e-bpmn-icons e-ParallelMI',
      //       id: 'Collectioncollection',
      //     },
      //   ],
      // },
      // {
      //   text: 'Call',
      //   id: 'DeftCall',
      //   items: [
      //     {
      //       text: 'None',
      //       iconCss: 'e-call e-bpmn-icons e-None',
      //       id: 'CallNone',
      //     },
      //     {
      //       text: 'Call',
      //       iconCss: 'e-call e-bpmn-icons e-CallActivity',
      //       id: 'CallCall',
      //     },
      //   ],
      // },
      // {
      //   text: 'Trigger Result',
      //   id: 'TriggerResult',
      //   items: [
      //     {
      //       text: 'None',
      //       id: 'TriggerNone',
      //       iconCss: 'e-trigger e-bpmn-icons e-None',
      //     },
      //     {
      //       text: 'Message',
      //       id: 'Message',
      //       iconCss: 'e-trigger e-bpmn-icons e-InMessage',
      //     },
      //     {
      //       text: 'Multiple',
      //       id: 'Multiple',
      //       iconCss: 'e-trigger e-bpmn-icons e-InMultiple',
      //     },
      //     {
      //       text: 'Parallel',
      //       id: 'Parallel',
      //       iconCss: 'e-trigger e-bpmn-icons e-InParallelMultiple',
      //     },
      //     {
      //       text: 'Signal',
      //       id: 'Signal',
      //       iconCss: 'e-trigger e-bpmn-icons e-InSignal',
      //     },
      //     {
      //       text: 'Timer',
      //       id: 'Timer',
      //       iconCss: 'e-trigger e-bpmn-icons e-InTimer',
      //     },
      //     {
      //       text: 'Cancel',
      //       id: 'Cancel',
      //       iconCss: 'e-trigger e-bpmn-icons e-CancelEnd',
      //     },
      //     {
      //       text: 'Escalation',
      //       id: 'Escalation',
      //       iconCss: 'e-trigger e-bpmn-icons e-InEscalation',
      //     },
      //     {
      //       text: 'Error',
      //       id: 'Error',
      //       iconCss: 'e-trigger e-bpmn-icons e-InError',
      //     },
      //     {
      //       text: 'Compensation',
      //       id: 'triggerCompensation',
      //       iconCss: 'e-trigger e-bpmn-icons e-InCompensation',
      //     },
      //     {
      //       text: 'Terminate',
      //       id: 'Terminate',
      //       iconCss: 'e-trigger e-bpmn-icons e-TerminateEnd',
      //     },
      //     {
      //       text: 'Conditional',
      //       id: 'Conditional',
      //       iconCss: 'e-trigger e-bpmn-icons e-InConditional',
      //     },
      //     {
      //       text: 'Link',
      //       id: 'Link',
      //       iconCss: 'e-trigger e-bpmn-icons e-ThrowLinkin',
      //     },
      //   ],
      // },
      // {
      //   text: 'Event Type',
      //   id: 'EventType',
      //   items: [
      //     {
      //       text: 'Start',
      //       id: 'Start',
      //       iconCss: 'e-event e-bpmn-icons e-NoneStart',
      //     },
      //     {
      //       text: 'Intermediate',
      //       id: 'Intermediate',
      //       iconCss: 'e-event e-bpmn-icons e-InterruptingNone',
      //     },
      //     {
      //       text: 'NonInterruptingStart',
      //       id: 'NonInterruptingStart',
      //       iconCss: 'e-event e-bpmn-icons e-Noninterruptingstart',
      //     },
      //     {
      //       text: 'ThrowingIntermediate',
      //       id: 'ThrowingIntermediate',
      //       iconCss: 'e-event e-bpmn-icons e-InterruptingNone',
      //     },
      //     {
      //       text: 'NonInterruptingIntermediate',
      //       id: 'NonInterruptingIntermediate',
      //       iconCss: 'e-event e-bpmn-icons e-NoninterruptingIntermediate',
      //     },
      //     { text: 'End', id: 'End', iconCss: 'e-event e-bpmn-icons e-NoneEnd' },
      //   ],
      // },
      // {
      //   text: 'Task Type',
      //   id: 'TaskType',
      //   items: [
      //     {
      //       text: 'None',
      //       id: 'TaskNone',
      //       iconCss: 'e-task e-bpmn-icons e-None',
      //     },
      //     {
      //       text: 'Service',
      //       id: 'Service',
      //       iconCss: 'e-task e-bpmn-icons e-ServiceTask',
      //     },
      //     {
      //       text: 'BusinessRule',
      //       id: 'BusinessRule',
      //       iconCss: 'e-task e-bpmn-icons e-BusinessRule',
      //     },
      //     {
      //       text: 'InstantiatingReceive',
      //       id: 'InstantiatingReceive',
      //       iconCss: 'e-task e-bpmn-icons e-InstantiatingReceive',
      //     },
      //     {
      //       text: 'Manual',
      //       id: 'Manual',
      //       iconCss: 'e-task e-bpmn-icons e-ManualCall',
      //     },
      //     {
      //       text: 'Receive',
      //       id: 'Receive',
      //       iconCss: 'e-task e-bpmn-icons e-InMessage',
      //     },
      //     {
      //       text: 'Script',
      //       id: 'Script',
      //       iconCss: 'e-task e-bpmn-icons e-ScriptCall',
      //     },
      //     {
      //       text: 'Send',
      //       id: 'Send',
      //       iconCss: 'e-task e-bpmn-icons e-InMessage',
      //     },
      //     {
      //       text: 'User',
      //       id: 'User',
      //       iconCss: 'e-task e-bpmn-icons e-UserCall',
      //     },
      //   ],
      // },
      // {
      //   text: 'GateWay',
      //   id: 'GateWay',
      //   iconCss: 'e-bpmn-icons e-Gateway',
      //   items: [
      //     {
      //       text: 'None',
      //       id: 'GatewayNone',
      //       iconCss: 'e-gate e-bpmn-icons e-None',
      //     },
      //     {
      //       text: 'Exclusive',
      //       iconCss: 'e-gate e-bpmn-icons e-ExclusiveGatewayWithMarker',
      //       id: 'Exclusive',
      //     },
      //     {
      //       text: 'Inclusive',
      //       iconCss: 'e-gate e-bpmn-icons e-InclusiveGateway',
      //       id: 'Inclusive',
      //     },
      //     {
      //       text: 'Parallel',
      //       iconCss: 'e-gate e-bpmn-icons e-ParallelGateway',
      //       id: 'GatewayParallel',
      //     },
      //     {
      //       text: 'Complex',
      //       iconCss: 'e-gate e-bpmn-icons e-ComplexGateway',
      //       id: 'Complex',
      //     },
      //     {
      //       text: 'EventBased',
      //       iconCss: 'e-gate e-bpmn-icons e-EventBasedGateway',
      //       id: 'EventBased',
      //     },
      //     {
      //       text: 'ExclusiveEventBased',
      //       iconCss: 'e-gate e-bpmn-icons e-ExclusiveEventBased',
      //       id: 'ExclusiveEventBased',
      //     },
      //     {
      //       text: 'ParallelEventBased',
      //       iconCss: 'e-gate e-bpmn-icons e-ParallelEventBasedGatewaytostart',
      //       id: 'ParallelEventBased',
      //     },
      //   ],
      // },
    ],
    showCustomMenuOnly: true,
  };

  public contextMenuOpen(args: DiagramBeforeMenuOpenEventArgs) {
    let hiddenId: string[] = [];
    if (args.element.className !== 'e-menu-parent e-ul ') {
      hiddenId = [
        'Adhoc',
        'Loop',
        'taskCompensation',
        'Activity-Type',
        'Boundry',
        'DataObject',
        'collection',
        'DeftCall',
        'TriggerResult',
        'EventType',
        'TaskType',
        'GateWay',
      ];
    }
    if (this.diagram_ONE.selectedItems.nodes.length) {
      for (const item of args.items) {
        const bpmnShape: BpmnShapeModel = this.diagram_ONE.selectedItems.nodes[0]
          .shape as BpmnShapeModel;
        if (bpmnShape.shape !== 'DataObject' && bpmnShape.shape !== 'Gateway') {
          if (item.text === 'Ad-Hoc') {
            if (bpmnShape.activity.activity === 'SubProcess') {
              hiddenId.splice(hiddenId.indexOf(item.id), 1);
            }
          }
          if (
            item.text === 'Loop' ||
            item.text === 'Compensation' ||
            item.text === 'Activity-Type'
          ) {
            if (bpmnShape.shape === 'Activity') {
              hiddenId.splice(hiddenId.indexOf(item.id), 1);
            }
          }
          if (item.text === 'Boundry') {
            if (bpmnShape.activity.activity === 'SubProcess') {
              hiddenId.splice(hiddenId.indexOf(item.id), 1);
            }
          }
        }
        if (item.text === 'Data Object') {
          if (bpmnShape.shape === 'DataObject') {
            hiddenId.splice(hiddenId.indexOf(item.id), 1);
          }
        }
        if (item.text === 'Collection') {
          if (bpmnShape.shape === 'DataObject') {
            hiddenId.splice(hiddenId.indexOf(item.id), 1);
          }
        }
        if (item.text === 'Call') {
          if (
            bpmnShape.shape === 'Activity' &&
            bpmnShape.activity.activity === 'Task'
          ) {
            hiddenId.splice(hiddenId.indexOf(item.id), 1);
          }
        }
        if (item.text === 'Trigger Result') {
          if (bpmnShape.shape === 'Event') {
            hiddenId.splice(hiddenId.indexOf(item.id), 1);
          }
        }
        if (item.text === 'Event Type') {
          if (bpmnShape.shape === 'Event') {
            hiddenId.splice(hiddenId.indexOf(item.id), 1);
          }
        }
        if (item.text === 'Task Type') {
          if (
            bpmnShape.shape === 'Activity' &&
            bpmnShape.activity.activity === 'Task'
          ) {
            hiddenId.splice(hiddenId.indexOf(item.id), 1);
          }
        }
        if (item.text === 'GateWay') {
          if (bpmnShape.shape === 'Gateway') {
            hiddenId.splice(hiddenId.indexOf(item.id), 1);
          }
        }
        if (
          args.parentItem &&
          args.parentItem.id === 'TriggerResult' &&
          bpmnShape.shape === 'Event'
        ) {
          if (
            item.text !== 'None' &&
            (item.text === bpmnShape.event.event ||
              item.text === bpmnShape.event.trigger)
          ) {
            hiddenId.push(item.id);
          }
          if (bpmnShape.event.event === 'Start') {
            if (
              item.text === 'Cancel' ||
              item.text === 'Terminate' ||
              item.text === 'Link'
            ) {
              hiddenId.push(item.id);
            }
          }
          if (
            bpmnShape.event.event === 'NonInterruptingStart' ||
            item.text === 'Link'
          ) {
            if (
              item.text === 'Cancel' ||
              item.text === 'Terminate' ||
              item.text === 'Compensation' ||
              item.text === 'Error' ||
              item.text === 'None'
            ) {
              hiddenId.push(item.id);
            }
          }
          if (bpmnShape.event.event === 'Intermediate') {
            if (item.text === 'Terminate') {
              hiddenId.push(item.id);
            }
          }
          if (bpmnShape.event.event === 'NonInterruptingIntermediate') {
            if (
              item.text === 'Cancel' ||
              item.text === 'Terminate' ||
              item.text === 'Compensation' ||
              item.text === 'Error' ||
              item.text === 'None' ||
              item.text === 'Link'
            ) {
              hiddenId.push(item.id);
            }
          }
          if (bpmnShape.event.event === 'ThrowingIntermediate') {
            if (
              item.text === 'Cancel' ||
              item.text === 'Terminate' ||
              item.text === 'Timer' ||
              item.text === 'Error' ||
              item.text === 'None' ||
              item.text === 'Pareller' ||
              item.text === 'Conditional'
            ) {
              hiddenId.push(item.id);
            }
          }
          if (bpmnShape.event.event === 'End') {
            if (
              item.text === 'Parallel' ||
              item.text === 'Timer' ||
              item.text === 'Conditional' ||
              item.text === 'Link'
            ) {
              hiddenId.push(item.id);
            }
          }
        }
        if (
          args.parentItem &&
          args.parentItem.id === 'EventType' &&
          bpmnShape.shape === 'Event'
        ) {
          if (item.text === bpmnShape.event.event) {
            hiddenId.push(item.id);
          }
        }
      }
    }
    args.hiddenItems = hiddenId;
  }


  public nodes: NodeModel[] = [
    {
      id: 'start',
      width: 40,
      height: 40,
      offsetX: 35,
      offsetY: 180,
      shape: {
        type: 'Bpmn',
        shape: 'Event',
        event: { event: 'Start' },
      },
    },
    {
      id: 'subProcess',
      width: 520,
      height: 250,
      offsetX: 355,
      offsetY: 180,
      constraints: NodeConstraints.Default | NodeConstraints.AllowDrop,
      shape: {
        shape: 'Activity',
        type: 'Bpmn',
        activity: {
          activity: 'SubProcess',
          subProcess: {
            type: 'Transaction',
            collapsed: false,
            processes: [
              'processesStart',
              'service',
              'compensation',
              'processesTask',
              'error',
              'processesEnd',
              'user',
              'subProcessesEnd',
            ],
          },
        },
      },
    },
    {
      id: 'hazardEnd',
      width: 40,
      height: 40,
      offsetX: 305,
      offsetY: 370,
      shape: {
        type: 'Bpmn',
        shape: 'Event',
        event: { event: 'End' },
      },
      annotations: [
        {
          id: 'label2',
          content: 'Hazard',
          style: { fill: 'white', color: 'black' },
          verticalAlignment: 'Top',
          margin: { top: 20 },
        },
      ],
    },
    {
      id: 'cancelledEnd',
      width: 40,
      height: 40,
      offsetX: 545,
      offsetY: 370,
      shape: {
        type: 'Bpmn',
        shape: 'Event',
        event: { event: 'End' },
      },
      annotations: [
        {
          id: 'cancelledEndLabel2',
          content: 'Cancelled',
          style: { fill: 'white', color: 'black' },
          verticalAlignment: 'Top',
          margin: { top: 20 },
        },
      ],
    },
    {
      id: 'end',
      width: 40,
      height: 40,
      offsetX: 665,
      offsetY: 180,
      shape: {
        type: 'Bpmn',
        shape: 'Event',
        event: { event: 'End' },
      },
    },
    {
      id: 'processesStart',
      width: 30,
      height: 30,
      shape: {
        type: 'Bpmn',
        shape: 'Event',
        event: { event: 'Start' },
      },
      margin: { left: 40, top: 80 },
    },
    {
      id: 'service',
      style: { fill: '#6FAAB0' },
      width: 95,
      height: 70,
      shape: {
        type: 'Bpmn',
        shape: 'Activity',
        activity: {
          activity: 'Task',
          task: { type: 'Service', loop: 'ParallelMultiInstance' },
        },
      },
      annotations: [
        {
          id: 'serviceLabel2',
          content: 'Book hotel',
          offset: { x: 0.5, y: 0.5 },
          style: { color: 'white' },
        },
      ],
      margin: { left: 110, top: 20 },
    },
    {
      id: 'compensation',
      width: 30,
      height: 30,
      shape: {
        type: 'Bpmn',
        shape: 'Event',
        event: { event: 'Intermediate', trigger: 'Compensation' },
      },
      margin: { left: 170, top: 100 },
    },
    {
      id: 'processesTask',
      style: { fill: '#F6B53F' },
      width: 95,
      height: 70,
      shape: {
        type: 'Bpmn',
        shape: 'Activity',
        activity: {
          activity: 'Task',
          task: {
            type: 'Service',
          },
        },
      },
      annotations: [
        {
          id: 'serviceLabel2',
          content: 'Charge credit card',
          offset: { x: 0.5, y: 0.6 },
          style: { color: 'white' },
        },
      ],
      margin: { left: 290, top: 20 },
    },
    {
      id: 'error',
      width: 30,
      height: 30,
      shape: {
        type: 'Bpmn',
        shape: 'Event',
        event: {
          event: 'Intermediate',
          trigger: 'Error',
        },
      },
      margin: { left: 350, top: 100 },
    },
    {
      id: 'processesEnd',
      width: 30,
      height: 30,
      shape: {
        type: 'Bpmn',
        shape: 'Event',
        event: { event: 'End' },
      },
      margin: { left: 440, top: 80 },
    },
    {
      id: 'user',
      style: { fill: '#E94649' },
      width: 90,
      height: 80,
      shape: {
        type: 'Bpmn',
        shape: 'Activity',
        activity: {
          activity: 'Task',
          task: {
            type: 'User',
            compensation: true,
          },
        },
      },
      annotations: [
        {
          id: 'serviceLabel2',
          content: 'Cancel hotel reservation',
          offset: { x: 0.5, y: 0.6 },
          style: { color: 'white' },
        },
      ],
      margin: { left: 240, top: 160 },
    },
    {
      id: 'subProcessesEnd',
      width: 30,
      height: 30,
      shape: {
        type: 'Bpmn',
        shape: 'Event',
        event: { event: 'End' },
      },
      margin: { left: 440, top: 210 },
    },
  ];


// SetNode Templates





  constructor(
    public gfunc: GlobalFunctionsService,
    private _demoService: DemoService,
    public toastr: HotToastService,
    private modalService: BsModalService,

  ) { }

  ngOnInit(): void {


// Context Menu
 //Enables the context menu
//  this.contextMenuSettings = {
//     //Enables the context menu
//     show: true,
//     items: [
//       {
//         text: "Cut  ",
//         id: "Cut",
//         target: ".e-diagramcontent",
//         iconCss: "e-Cut"
//       },
//       {
//         text: "Copy  ",
//         id: "Copy",
//         target: ".e-diagramcontent",
//         iconCss: "e-Copy"
//       }
//     ],
//     // Hides the default context menu items
//     showCustomMenuOnly: true
//   };


            // this.snapSettings_ONE = {
            // constraints: 0
            // }
            // this.items_ONE = new DataManager(this.data_ONE as JSON[], new Query().take(7));
            // //Uses layout to auto-arrange nodes on the Diagram page
            // this.layout_ONE = {
            // //Sets layout type
            // type: 'HierarchicalTree'
            // }
            // //Configures data source for Diagram
            // this.dataSourceSettings_ONE = {
            // id: 'Name',
            // parentId: 'ReportingPerson',
            // dataSource: this.items_ONE
            // }

  }




  ngOnChanges(changes): void  {
 
    // this.search_model = new AppRoute()

    // this.toastr.success('we detected onchanges diagram chart...')


 if(this.widget_size == 'under_the_hood'){
// this.toastr.info('Under the Hood')
// this.search_model = new AppRoute()
//   this.getAppRoutesSearchFull(this.search_model);
 }



    if (changes.item_data) {
      this.new_data = changes.item_data.currentValue;
      console.log('New Data Loaded: ', JSON.stringify(this.new_data));



                // Working function to filter and create an array Log Type Items - Triggers Exists in .. (system_automations_array)
                this.array_of_routes = [{
                  app_route_name: "Application Routes",
                  app_route_id: "parent",
                  // Role: "Site Map"
                }];
                // Count items of brand search to loop through
                let  count_of_trigger_items = Object.keys(this.new_data).length;
                // now loop and push to join model
                for(let i=0;i < count_of_trigger_items; i++) {
                  
                  // let res2 = this.new_data[i];
                  let res2 = this.new_data[i];

                  // var logs_type_triggers = JSON.parse(data[i].system_automation_array);
                    // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
                    // if(logs_type_triggers.some(person => person == this.system_automation_id )){ } // end if exists in the current row array
              
                    if(res2.app_route_parent_id != 0 && res2.app_route_parent_id != null)
                    this.array_of_routes.push({
                  //  log_type_name: res2.log_type_name,
                  //  log_type_id: res2.log_type_id,
                  //  log_type_colour: res2.log_type_colour,
                  //  log_type_icon: res2.log_type_icon,
                  //  log_type_description: res2.log_type_description,
                  //  is_active: res2.is_active,
                // <h4>  {{data.file_number}} :: {{data.app_route_number}} :: {{data.app_route_child_number}} </h4>

                      app_route_id: res2.app_route_id,
                      app_route_parent_id: res2.app_route_parent_id,
                      app_route_name: res2.file_number + '.' + res2.app_route_number + '.' + res2.app_route_child_number + ' - '  + res2.app_route_name,
                      app_route_colour: res2.app_route_colour,
                      item_data: res2,

                            });
                  if(res2.app_route_parent_id == 0 || res2.app_route_parent_id == null){
                    this.array_of_routes.push({
                          app_route_id: res2.app_route_id,
                          // app_route_parent_id: res2.app_route_parent_id,
                          app_route_name: res2.file_number + '.' + res2.app_route_number + '.' + res2.app_route_child_number + ' - ' + res2.app_route_name,
                          app_route_colour: res2.app_route_colour,
                          item_data: res2,

                                });
                  }

              
                          
                
                } // end app routes loop.
                
                this.array_of_routes = this.array_of_routes;


                // this.data_LOCAL_DATA_RECIEVED =  {
                //   id: 'app_route_id', parentId: 'app_route_parent_id', dataManager: new DataManager(this.array_of_routes),
                //   //binds the external data with node
                //   doBinding: (nodeModel: NodeModel, data: DataInfo, diagram_ONE: Diagram) => {
                //       nodeModel.annotations = [{
                //           /* tslint:disable:no-string-literal */
                //           content: data['app_route_name'], margin: { top: 10, left: 10, right: 10, bottom: 0 },
                //           style: { color: 'black' }
                //       }];
                //       /* tslint:disable:no-string-literal */
                //       nodeModel.style = { fill: '#ffeec7', strokeColor: '#f5d897', strokeWidth: 1 };
                //   }
                // };
          

                this.snapSettings_ONE = {
                    constraints: 0
                }
                this.items_ONE = new DataManager(this.array_of_routes as JSON[], new Query().take(7));
                //Uses layout to auto-arrange nodes on the Diagram page
                this.layout_ONE = {
                    //Sets layout type
                    type: 'HierarchicalTree'
                }
                //Configures data source for Diagram
                this.dataSourceSettings_ONE = {
                    id: 'app_route_id',
                    parentId: 'app_route_parent_id',
                    dataSource: this.items_ONE
                }




    }

  }


    
  getAppRoutesSearchFull(search_model) {
    // search_model.brand_type_id = 3;
    // search_model.access_level = 5;
    this._demoService.getAppRoutesSearchFull(search_model).subscribe(
      data => { this.app_routes_metrix_search_full = data;
       let res = data[0];
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
       
       
        this.app_routes_metrix_search_full_results = DataUtil.parse.parseJson(data);
        // this.subject_service_metrix_search_full_results = data;
        this.new_data = this.app_routes_metrix_search_full_results.slice(0, 500);
  
        // const species: object[] = [
        //   { 'Name': 'Species', 'fillColor': '#3DD94A' },
        //   { 'Name': 'Plants', 'Category': 'Species' },
        //   { 'Name': 'Fungi', 'Category': 'Species' },
        //   { 'Name': 'Lichens', 'Category': 'Species' },
        //   { 'Name': 'Animals', 'Category': 'Species' },
        //   { 'Name': 'Mosses', 'Category': 'Plants' },
        //   { 'Name': 'Ferns', 'Category': 'Plants' },
        //   { 'Name': 'Gymnosperms', 'Category': 'Plants' },
        //   { 'Name': 'Dicotyledens', 'Category': 'Plants' },
        //   { 'Name': 'Monocotyledens', 'Category': 'Plants' },
        //   { 'Name': 'Invertebrates', 'Category': 'Animals' },
        //   { 'Name': 'Vertebrates', 'Category': 'Animals' },
        //   { 'Name': 'Insects', 'Category': 'Invertebrates' },
        //   { 'Name': 'Molluscs', 'Category': 'Invertebrates' },
        //   { 'Name': 'Crustaceans', 'Category': 'Invertebrates' },
        //   { 'Name': 'Others', 'Category': 'Invertebrates' },
        //   { 'Name': 'Fish', 'Category': 'Vertebrates' },
        //   { 'Name': 'Amphibians', 'Category': 'Vertebrates' },
        //   { 'Name': 'Reptiles', 'Category': 'Vertebrates' },
        //   { 'Name': 'Birds', 'Category': 'Vertebrates' },
        //   { 'Name': 'Mammals', 'Category': 'Vertebrates' }
        // ];

        // this.species = species

      //  this.grid.refresh();
    
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
        );     
      }












 //Sets the default properties for all the Nodes
 public getNodeDefaults_ONE(obj: NodeModel, diagram_ONE: Diagram): NodeModel {
  obj.shape = {
      type: 'Text',
      content: (obj.data as {app_route_name: 'string'}).app_route_name
    
  };
  obj.style = {
      fill: 'None',
      strokeColor: 'none',
      strokeWidth: 2,
      bold: true,
      color: 'black'
  };
  let colour = (obj.data as {app_route_colour: 'string'}).app_route_colour
  if(colour != null) {
    obj.borderColor =   (obj.data as {app_route_colour: 'string'}).app_route_colour
  }else{
  obj.borderColor = '#7eafcc';
  }

  
  obj.width = 100;
  obj.height = 40;
  obj.backgroundColor = 'white';
  obj.borderWidth = 1;
  (obj.shape as TextModel).margin = {
      left: 5,
      right: 5,
      top: 5,
      bottom: 5
  };
  return obj;
}

// Make this into a function so that I can set any value with the node type.
//Sets the default properties for all the connectors
public getConnectorDefaults_ONE(connector: ConnectorModel, diagram_ONE: Diagram): ConnectorModel {
  connector.style = {
      strokeColor: '#3e2c42',
      strokeWidth: 2
  };
  (((connector as ConnectorModel).targetDecorator as DecoratorModel).style as ShapeStyleModel).fill = '#fb6e40';
  (((connector as ConnectorModel).targetDecorator as DecoratorModel).style as ShapeStyleModel).strokeColor = '##fb6e40';
  connector.type = 'Orthogonal';
  return connector;
}



// Modals open with component
  // MODAL view a component
  openModalWithComponent_CreateAppBaseRouteChildMaster(item_data) {
    const initialState = {
      title: 'Upload Template Document',
      is_modal: true,
      item_id: 1010,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
      item_data: item_data[4], // the fivth is the full object of the current rout.// enable the proper number counts
      widget_size: 'create_base_child_route',
    };
    this.bsModalRef = this.modalService.show(AppRouteCreateWidgetComponent, {initialState});
    // sets the var to in the component model

    // Need to set the item_data -- to set the counds and get all correct field properties.

    // this.bsModalRef.content.item_data = args.item;
    this.bsModalRef.content.widget_size = 'create_base_child_route';
    this.bsModalRef.content.widget_title = 'Create Base CHILD Route Master NODAL UTH';

    this.bsModalRef.content.app_route_id = '';
    this.bsModalRef.content.app_route_parent_id ='';
    this.bsModalRef.content.title = 'Create Master Base Child Route';
    this.bsModalRef.content.closeBtnName = 'Close';

    //  this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// Angular 14 working.....

   }


   openModalWithComponent_CreateAppBaseRouteChildTaskItem(item_data) {
    const initialState = {
      title: 'Upload Template Document',
      is_modal: true,
      item_id: 1010,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
      item_data: item_data[4], // the fivth is the full object of the current rout.// enable the proper number counts
      widget_size: 'create_child_task',
    };
    this.bsModalRef = this.modalService.show(AppRouteCreateWidgetComponent, {initialState});
    // sets the var to in the component model

    // Need to set the item_data -- to set the counds and get all correct field properties.

    // this.bsModalRef.content.item_data = args.item;
    this.bsModalRef.content.widget_size = 'create_child_task';
    this.bsModalRef.content.widget_title = 'Create A Child Route NODAL UTH';

    // this.bsModalRef.content.app_route_id = '';
    // this.bsModalRef.content.app_route_parent_id ='';
    // this.bsModalRef.content.title = 'Create Master Base Child Route';
    // this.bsModalRef.content.closeBtnName = 'Close';

    //  this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// Angular 14 working.....

   }





   openModalWithComponent_UpdateAppBaseRouteItem(item_data) {
    const initialState = {
      title: 'Update Route',
      is_modal: true,
      // item_id: 1010,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
      item_data: item_data[4], // the fivth is the full object of the current rout.// enable the proper number counts
      widget_size: '',
      app_route_id: item_data[4].app_route_id,
     
    };
    this.bsModalRef = this.modalService.show(AppRouteUpdateWidgetComponent, {initialState});
    // sets the var to in the component model
    // closeParentModel: this.closeParentModel()

    // Need to set the item_data -- to set the counds and get all correct field properties.

    // this.bsModalRef.content.item_data = args.item;
    this.bsModalRef.content.widget_size = '';
    this.bsModalRef.content.widget_title = 'Update Route';

    // this.bsModalRef.content.app_route_id = '';
    // this.bsModalRef.content.app_route_parent_id ='';
    // this.bsModalRef.content.title = 'Create Master Base Child Route';
    // this.bsModalRef.content.closeBtnName = 'Close';

    //  this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// Angular 14 working.....

   }



   openModalWithComponent_ViewAppBaseRouteItem(item_data) {
    const initialState = {
      title: 'Route',
      is_modal: true,
      // item_id: 1010,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
      // item_data: item_data[4], // the fivth is the full object of the current rout.// enable the proper number counts
      // widget_size: '',
      app_route_id: item_data[4].app_route_id,
      item_id: item_data[4].app_route_id,
      
     
    };
    this.bsModalRef = this.modalService.show(AppRouteWidgetComponent, {initialState});
    // sets the var to in the component model
    // closeParentModel: this.closeParentModel()

    // Need to set the item_data -- to set the counds and get all correct field properties.

    // this.bsModalRef.content.item_data = args.item;
    // this.bsModalRef.content.widget_size = '';
    this.bsModalRef.content.widget_title = 'Route';

    // this.bsModalRef.content.app_route_id = '';
    // this.bsModalRef.content.app_route_parent_id ='';
    // this.bsModalRef.content.title = 'Create Master Base Child Route';
    // this.bsModalRef.content.closeBtnName = 'Close';

    //  this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// Angular 14 working.....

   }


// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};




}




export interface DataInfo {
    [key: string]: string;
  }




  //Defines the clone tool used to copy Node/Connector
class CloneTool extends MoveTool {
    public diagram_ONE?: Diagram = undefined;
    public override mouseDown(args: MouseEventArgs): void {
      let newObject: NodeModel | ConnectorModel;
      if (((this.diagram_ONE as Diagram).selectedItems.nodes as NodeModel[]).length > 0) {
        newObject = cloneObject(((this.diagram_ONE as Diagram).selectedItems.nodes as NodeModel[])[0]) as NodeModel;
      } else {
        newObject = cloneObject((((this.diagram_ONE as Diagram).selectedItems as SelectorModel).connectors as ConnectorModel[])[0]) as ConnectorModel;
      }
      newObject.id += randomId();
      (this.diagram_ONE as Diagram).paste([newObject]);
      args.source = (this.diagram_ONE as Diagram).nodes[(this.diagram_ONE as Diagram).nodes.length - 1] as IElement;
      args.sourceWrapper = args.source.wrapper;
      super.mouseDown(args);
      this.inAction = true;
    }
  }